import { render } from "./skeletonItem.vue?vue&type=template&id=352e1082"
import script from "./skeletonItem.vue?vue&type=script&lang=js"
export * from "./skeletonItem.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./skeletonItem.vue?vue&type=style&index=0&id=352e1082&module=true&lang=less"
cssModules["$style"] = style0

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__